import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OESurgeryTargetType, OESurgeryTargets, OESurgeryFeatureAccess, OESurgeryStartSelectionData} from './oe-surgery-model';

export default class OESurgeryCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OESurgeryTargetType.anatomy]:       {icon: OEIconCodes.surgery.anatomyTarget, titleId: 'cap_bar_target_title_anatomy'},
            [OESurgeryTargetType.approachOp]:    {icon: OEIconCodes.surgery.approachOpTarget, titleId: 'cap_bar_target_title_approach_op'},
            [OESurgeryTargetType.ophthalmology]: {icon: OEIconCodes.surgery.ophthalmologyTarget, titleId: 'cap_bar_target_title_ophthalmology'},
            [OESurgeryTargetType.orthoOp]:       {icon: OEIconCodes.surgery.orthoOpTarget, titleId: 'cap_bar_target_title_ortho_op'},
            [OETarget.effigosExplorerHelp]:      {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        //let targetTypes = [OESurgeryTargetType.anatomy, OESurgeryTargetType.approachOp, OESurgeryTargetType.ophthalmology, OESurgeryTargetType.orthoOp, OETarget.effigosExplorerHelp];

        let targetTypes = OESurgeryStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OESurgeryTargets}
                featureAccess={OESurgeryFeatureAccess}
                startSelectionData={OESurgeryStartSelectionData}
            />
        );
    }
}